// 講師派遣申し込みフォーム ログイン画面のクライアントスクリプト。
//
// eleventy.config.ts の bundleClientScripts が esbuild でバンドルし、
// login.11ty.tsx から <script src> で読み込む。
//
// /api/session/lecture でセッションを発行し、成功したら元のURL
// （lecture/form/ 配下の Lambda@Edge が付与した ?redirect= 、無ければ
// フォーム入力画面）へ遷移する。URL は ../shared.ts に集約している。

import { FORM_URL, ready } from "./shared.js";

/**
 * `redirect` クエリパラメータを同一オリジンの相対パスとしてのみ受け入れる。
 * `URL` にパースしてオリジンを比較することで、`//` や `\` によるプロトコル
 * 相対URLなど文字列パターンでの回避策を個別に潰す必要をなくす。
 */
function safeRedirectTarget(value: string | null): string | undefined {
  if (!value) return undefined;
  try {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin) return undefined;
    return url.pathname + url.search + url.hash;
  } catch {
    return undefined;
  }
}

ready(() => {
  const form = document.getElementById(
    "lecture_login_form",
  ) as HTMLFormElement | null;
  if (!form) return;

  const idInput = document.getElementById(
    "login_id",
  ) as HTMLInputElement | null;
  const passwordInput = document.getElementById(
    "password",
  ) as HTMLInputElement | null;
  const errorEl = document.getElementById("login_error");

  form.addEventListener("submit", (event) => {
    // 静的サイトなので POST 先は無い。常に JS で処理する。
    event.preventDefault();

    const loginId = idInput?.value.trim() ?? "";
    const password = passwordInput?.value ?? "";

    if (!loginId || !password) {
      if (errorEl) {
        errorEl.textContent = "ログインIDとパスワードを入力してください";
      }
      (loginId ? passwordInput : idInput)?.focus();
      return;
    }

    if (errorEl) errorEl.textContent = "";

    fetch("/api/session/lecture", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: loginId, password }),
    })
      .then((res) => {
        if (!res.ok) {
          if (errorEl) {
            errorEl.textContent =
              "ログインIDまたはパスワードが正しくありません";
          }
          return;
        }
        const redirect = safeRedirectTarget(
          new URLSearchParams(window.location.search).get("redirect"),
        );
        window.location.href = redirect ?? FORM_URL.input;
      })
      .catch(() => {
        if (errorEl) {
          errorEl.textContent =
            "通信に失敗しました。しばらくしてから再度お試しください";
        }
      });
  });
});
